/**
 * The handful of glyphs the app draws itself.
 *
 * Emoji were the first draft and they were the wrong tool: every platform ships its own
 * artwork, they ignore `currentColor`, and at 12px in a table row they read as a smudge.
 * These are drawn on the text baseline in the ink colour, so a locked row looks like part
 * of the ledger rather than a sticker on it.
 */

import { cn } from "../../lib/utils";

type IconProps = { className?: string; title?: string };

export function LockIcon({ className, title = "Locked" }: IconProps) {
  return (
    <svg
      viewBox="0 0 12 12"
      aria-label={title}
      role="img"
      className={cn("h-3 w-3 shrink-0 text-muted", className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <title>{title}</title>
      <rect x="2.25" y="5.25" width="7.5" height="5.25" rx="1.25" />
      <path d="M4.25 5.25V3.75a1.75 1.75 0 0 1 3.5 0v1.5" />
    </svg>
  );
}

export function HomeIcon({ className, title = "All groups" }: IconProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      aria-label={title}
      role="img"
      className={cn("h-4 w-4 shrink-0", className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <title>{title}</title>
      <path d="M2.5 6.75 8 2.5l5.5 4.25V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
      <path d="M6.5 13.5v-4h3v4" />
    </svg>
  );
}

export function CameraIcon({ className, title = "Take a photo" }: IconProps) {
  return (
    <svg
      viewBox="0 0 20 20"
      aria-label={title}
      role="img"
      className={cn("h-5 w-5 shrink-0", className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <title>{title}</title>
      <path d="M2.75 6.75h2.9l1.2-1.9h6.3l1.2 1.9h2.9a1 1 0 0 1 1 1v7.5a1 1 0 0 1-1 1H2.75a1 1 0 0 1-1-1v-7.5a1 1 0 0 1 1-1Z" />
      <circle cx="10" cy="11.25" r="2.9" />
    </svg>
  );
}

export function PhotoIcon({ className, title = "Choose a photo" }: IconProps) {
  return (
    <svg
      viewBox="0 0 20 20"
      aria-label={title}
      role="img"
      className={cn("h-5 w-5 shrink-0", className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <title>{title}</title>
      <rect x="2.25" y="3.75" width="15.5" height="12.5" rx="1.5" />
      <circle cx="7" cy="8" r="1.4" />
      <path d="M2.75 13.5 6.9 9.9l3.1 2.6 2.6-2.1 4.15 3.4" />
    </svg>
  );
}


export function CheckIcon({ className, title = "Done" }: IconProps) {
  return (
    <svg
      viewBox="0 0 12 12"
      aria-label={title}
      role="img"
      className={cn("h-3 w-3 shrink-0", className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <title>{title}</title>
      <path d="M2.5 6.25 4.75 8.5 9.5 3.75" />
    </svg>
  );
}
